import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Star, Quote } from "lucide-react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
const testimonials = [{
  id: 1,
  name: "Nagy Péter",
  location: "Üzleti utazó",
  content: "A repülőjegy és hotel foglalási rendszerük hihetetlenül gördülékeny. Egyetlen felületen sikerült elintéznem a teljes üzleti utamat, beleértve a reptéri taxit is. Mindenkinek csak ajánlani tudom!",
  rating: 5,
  avatarSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/traveler_peter_nagy.png",
  avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/traveler_peter_nagy.png-wvc-srcset",
  avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/traveler_peter_nagy.png-wvc-sizes"
}, {
  id: 2,
  name: "Kovács Adél",
  location: "Családi nyaraló",
  content: "Féltem az online foglalástól, de a keresőmotorjuk a legjobb árakat találta meg a tengerparti szállásokra. A visszaigazolás azonnal megérkezett, és a helyszínen is minden rendben volt.",
  rating: 5,
  avatarSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/traveler_adel_kovacs.png",
  avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/traveler_adel_kovacs.png-wvc-srcset",
  avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/traveler_adel_kovacs.png-wvc-sizes"
}, {
  id: 3,
  name: "Szabó Márk",
  location: "Hátizsákos kalandor",
  content: "A taxi foglalási funkció megmentette az életemet egy ismeretlen városban éjszaka. Megbízható sofőr, tiszta autó és korrekt ár. A legjobb utazási platform, amit eddig használtam.",
  rating: 5,
  avatarSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/traveler_mark_szabo.png",
  avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/traveler_mark_szabo.png-wvc-srcset",
  avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/traveler_mark_szabo.png-wvc-sizes"
}];
export default function TemoignagesClients() {
  return <section data-section-id="252665" id="customerreviews" className="bg-background text-foreground py-16 md:py-24">
      <div className="page-container">
        <div className="mx-auto max-w-2xl text-center mb-12 md:mb-16">
          <h2 className="font-default text-3xl md:text-5xl font-bold text-foreground mb-4">
            Utazóink véleménye
          </h2>
          <p className="text-muted-foreground text-lg font-default">
            Ismerje meg, miért választják több ezren a mi keresőmotorunkat szállás, repülőjegy és taxi foglaláshoz világszerte.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((testimonial, i) => <Card key={testimonial.id} data-index={i} className="relative h-full flex flex-col overflow-hidden border-none rounded-2xl shadow-lg hover:shadow-xl hover:scale-[1.02] transition-all duration-300 bg-card">
              <div className="absolute top-4 right-4 text-primary/20">
                <Quote className="size-12" aria-hidden="true" />
              </div>
              
              <CardHeader className="flex flex-row items-center gap-4 pb-4 relative z-10">
                <SafeHydrate><Avatar className="size-14 border-2 border-primary/20 shadow-sm">
                  <AvatarImage src={testimonial.avatarSrc} data-wvc-srcset={testimonial.avatarSrcset} data-wvc-sizes={testimonial.avatarSizes} alt={`Portrait de ${testimonial.name}`} />
                  <AvatarFallback className="bg-primary/10 text-primary font-semibold font-default">
                    {testimonial.name.charAt(0)}
                  </AvatarFallback>
                </Avatar></SafeHydrate>
                <div className="flex flex-col">
                  <span className="font-default font-bold text-foreground text-lg leading-tight">
                    {testimonial.name}
                  </span>
                  <span className="text-sm text-muted-foreground font-default">
                    {testimonial.location}
                  </span>
                </div>
              </CardHeader>
              
              <CardContent className="flex-1 flex flex-col relative z-10">
                <div className="flex items-center gap-1 mb-4 text-primary">
                  {Array.from({
                length: testimonial.rating
              }).map((_, index) => <Star key={index} className="size-4 fill-current" aria-hidden="true" />)}
                </div>
                <p className="text-foreground/90 leading-relaxed italic font-default">
                  "{testimonial.content}"
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}